exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".page-container .bg {\n  margin: auto;\n  width: 75vw;\n  height: 75vh;\n  background-size: cover;\n  mix-blend-mode: overlay;\n}\n", ""]);

